export default {
  Title: 'Playbooks',
  Subtitle: 'Reusable plans',
  NewPlaybook: '+ Playbook',
  Empty: 'No playbooks yet.',
  Client: 'Client',
  Caregiver: 'Caregiver',
  Execute: 'Execute',
  ExecutePlaceholder: 'Type / to run a playbook or skill',
  Executing: 'running command...',
  NoMatches: 'No matches found.',
  ReadyToExecute: 'Press Enter to execute #{playbook} for #{resource}.',
};
